import { forwardRef } from "react";

import { Icon } from "../icon/Icon";

import type { IconProps } from "../icon/Icon";

export interface VideoControlProps {
  type:
    | "play-pause"
    | "replay"
    | "go-backward"
    | "go-forward"
    | "closed-captioning"
    | "fullscreen"
    | "fullscreen-swap"
    | "airplay"
    | "pip";
  size?: IconProps["size"];
  isActive?: boolean;
  onClick?: () => void;
}

const DEFAULT_ICON_PROPS = {
  size: "lg",
};

export function getIconProps(
  type: string,
  isActive: boolean = false,
): IconProps {
  switch (type) {
    case "closed-captioning":
      return {
        icon: "closed-captioning",
        variant: isActive ? "solid" : "regular",
      };
    case "airplay":
      return {
        icon: "airplay",
        variant: isActive ? "solid" : "regular",
      };
    case "fullscreen":
      return {
        icon: isActive
          ? "down-left-and-up-right-to-center"
          : "up-right-and-down-left-from-center",
      };
    case "fullscreen-swap":
      return {
        icon: "rectangles-2-swap",
        variant: "solid",
      };
    case "pip":
      return {
        icon: isActive ? "pip-exit" : "pip-enter",
      };
    case "go-backward":
      return {
        icon: "go-backward-15",
        size: "xl",
      };
    case "go-forward":
      return {
        icon: "go-forward-30",
        size: "xl",
      };
    case "play-pause":
      return {
        icon: isActive ? "play" : "pause",
        variant: "solid",
        size: "var(--size-6)",
      };
    case "replay":
      return {
        icon: "arrow-rotate-right",
        variant: "regular",
        size: "var(--size-6)",
      };
    default:
      return { icon: "circle-question" };
  }
}

export const VideoControl = forwardRef<HTMLButtonElement, VideoControlProps>(
  function VideoControlImpl({ type, isActive, onClick }, ref) {
    const iconProps = {
      ...DEFAULT_ICON_PROPS,
      ...getIconProps(type, isActive),
    };

    return (
      <button ref={ref} className="VideoControl" onClick={onClick}>
        <Icon {...iconProps} />
      </button>
    );
  },
);
